import React from 'react';
import { bool, func, string } from 'prop-types';
import { CloseEyeIcon, smallEyeIcon } from '../theme/images';

const ShowPasswordByIcon = ({
  isPasswordEyeOpen,
  setIsPasswordEyeOpen,
  value,
}) => {
  if (!value || value.length === 0) {
    return null;
  }

  return isPasswordEyeOpen ? (
    <img
      src={smallEyeIcon}
      className="hide-icon cursor"
      alt="hide password"
      onClick={() => setIsPasswordEyeOpen(false)}
      role="presentation"
    />
  ) : (
    <img
      src={CloseEyeIcon}
      className="show-icon cursor"
      alt="show password"
      onClick={() => setIsPasswordEyeOpen(true)}
      role="presentation"
    />
  );
};

export default ShowPasswordByIcon;

ShowPasswordByIcon.propTypes = {
  isPasswordEyeOpen: bool.isRequired,
  setIsPasswordEyeOpen: func.isRequired,
  value: string.isRequired,
};
